import { render } from "./IntentionSetterV1.vue?vue&type=template&id=ece745c8&scoped=true"
import script from "./IntentionSetterV1.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1.vue?vue&type=script&lang=js"

import "./IntentionSetterV1.vue?vue&type=style&index=0&id=ece745c8&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece745c8"]])

export default __exports__